import { publicConfig } from '@/config/public'
import { CONTENT_TYPE_ROUTES } from '@/constants/content-type-routes'
import { generateSlug } from '@/utils/url'

type TypeName =
  | 'DatoCmsPctPaper'
  | 'DatoCmsPctPost'
  | 'DatoCmsPctInterview'
  | 'DatoCmsPctDialog'
  | 'DatoCmsPctPage'
  | 'DatoCmsPctTag'
  | 'DatoCmsPctTopic'
  | 'DatoCmsPctProject'
  | 'DatoCmsPctInternalPage'
  | 'DatoCmsPctEpisode'
  | 'DatoCmsGctPerson'
  | 'DatoCmsPctReport'
  | 'DatoCmsPctExternalContent'
  | 'DatoCmsPctEvent'
  | 'DatoCmsPctVision'

const MODEL_RELATION: Record<string, TypeName> = {
  pct_paper: 'DatoCmsPctPaper',
  pct_post: 'DatoCmsPctPost',
  pct_interview: 'DatoCmsPctInterview',
  pct_dialog: 'DatoCmsPctDialog',
  pct_page: 'DatoCmsPctPage',
  pct_tag: 'DatoCmsPctTag',
  pct_topic: 'DatoCmsPctTopic',
  pct_project: 'DatoCmsPctProject',
  pct_internal_page: 'DatoCmsPctInternalPage',
  pct_episode: 'DatoCmsPctEpisode',
  gct_person: 'DatoCmsGctPerson',
  pct_report: 'DatoCmsPctReport',
  pct_external_content: 'DatoCmsPctExternalContent',
  pct_event: 'DatoCmsPctEvent',
  pct_vision: 'DatoCmsPctVision'
}

export function convertModelToType(model: string): TypeName {
  return MODEL_RELATION[model]
}

const normalizeSlug = (slug: null | string | (null | string)[]): string => {
  if (typeof slug === 'string') {
    return slug
  }
  if (Array.isArray(slug)) {
    const parts = slug.filter(
      (part): part is string => part !== null && part !== ''
    )
    return parts.length > 0 ? generateSlug(parts) : ''
  }
  return ''
}
export function generateUrl(
  type: TypeName | undefined,
  slug: null | string | (null | string)[] = '',
  absolute = false,
  hashValue = ''
): string {
  if (type === 'DatoCmsPctExternalContent') {
    return Array.isArray(slug) ? (slug[0] ?? '') : (slug ?? '')
  }

  const url = normalizeSlug(slug)

  if (url === '') {
    return ''
  }

  const hash = hashValue ? `#${hashValue}` : ''
  const prefix = type ? (CONTENT_TYPE_ROUTES[type] ?? '') : ''

  return `${absolute ? publicConfig.app.url : ''}${prefix}/${url}/${hash}`
}

export const getAbsoluteUrl = (siteUrl: string, pathname: string): string =>
  `${siteUrl}${pathname}`
